import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { hotComments } from '@/mocks/trending';

export default function CommentWall() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  return (
    <section id="voices" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <SectionHeading
          eyebrow="热议焦点"
          title="大家都在怎么聊今天这件事"
          description="下面的内容来自公开讨论区的观点摘录，只呈现讨论氛围，不代表站方立场，也不构成事实认定。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotComments.map((comment) => {
            const isLiked = !!liked[comment.id];
            const likeCount = comment.likes + (isLiked ? 1 : 0);
            return (
              <figure
                key={comment.id}
                className="bg-background-100 border border-background-200 rounded-lg p-5 flex flex-col"
              >
                <blockquote className="text-sm text-foreground-700 leading-7 flex-1">
                  “{comment.content}”
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between">
                  <span className="flex items-center gap-2.5">
                    <span className="w-8 h-8 rounded-full bg-secondary-200 text-secondary-900 flex items-center justify-center text-xs font-semibold">
                      {comment.user.slice(0, 1)}
                    </span>
                    <span className="flex flex-col leading-tight">
                      <span className="text-xs font-medium text-foreground-800">{comment.user}</span>
                      <span className="text-[11px] text-foreground-400">{comment.time}</span>
                    </span>
                  </span>
                  <button
                    type="button"
                    aria-pressed={isLiked}
                    aria-label={`点赞这条观点，当前 ${likeCount} 个赞`}
                    onClick={() => setLiked((prev) => ({ ...prev, [comment.id]: !prev[comment.id] }))}
                    className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs transition-colors ${
                      isLiked
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-50 text-foreground-500 hover:text-foreground-800'
                    }`}
                  >
                    <i className={isLiked ? 'ri-heart-fill' : 'ri-heart-line'} aria-hidden="true"></i>
                    {likeCount}
                  </button>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}